import React from "react";
import { buildProfileImageSrc } from "../../utils/profileImage";
import "./ProfileAvatar.css";

const ProfileAvatar = ({
  src,
  cacheVersion,
  alt = "",
  className = "",
  onError,
  ...props
}) => {
  const imageSrc = buildProfileImageSrc(src, cacheVersion);

  if (!imageSrc) {
    return null;
  }

  return (
    <img
      src={imageSrc}
      alt={alt}
      className={`profile-avatar-img${className ? ` ${className}` : ""}`}
      decoding="async"
      onError={onError}
      {...props}
    />
  );
};

export default ProfileAvatar;
